import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, state, group, query, animateChild } from '@angular/animations';
import { WorkoutRoutine } from '../round/round.component';
import { HttpJsonService } from '../../services/http-json.service';

@Component({
  selector: 'interval',
  templateUrl: './interval.component.html',
  styleUrls: ['./interval.component.scss'],
  animations: [
    trigger('routine-container', [
      transition(':enter', [
        style({ opacity: '0' }),
        group([
          animate('1500ms ease-out', style({ opacity: '1' })),
          query('@image, @message', [
            animateChild()
          ])
        ])

      ]),
      transition(':leave', [
        group([
          animate('1500ms ease-out', style({ opacity: '0' })),
          query('@image, @message', [
            animateChild()
          ])
        ])
      ])
    ]),
    trigger('image', [
      transition(':enter', [
        // state('flyIn', style({ transform: 'translateX(0)' })),
        state('flyIn', style({ opacity: '1' })),
        // style({ transform: 'translateX(-100%)' }),
        style({ opacity: '0' }),
        animate('.5s 800ms ease-in')
      ]),
      transition(':leave', [
        // animate('0.3s ease-out', style({ transform: 'translateX(100%)' }))
        animate('0.8s ease-out', style({ opacity: '0' }))
      ])
    ]),

    trigger('message', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('500ms 1000ms ease-out', style({ opacity: '1' }))
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: '0' }))
      ])
    ])
  ]
})
export class IntervalComponent implements OnInit {
  isOpen = false;
  public displayContainer: boolean = false;

  @Input() workoutType:string;
  @Output() onDone = new EventEmitter();

  routines: WorkoutRoutine[];
  routine: WorkoutRoutine;
  shuffledRoutineIndexes: number[];
  indexCounter: number = 0;
  currentImage: string;

  constructor(public api: HttpJsonService) { }

  onNext() {
    this.currentImage = undefined;
    this.indexCounter++;
    if (this.indexCounter > this.shuffledRoutineIndexes.length - 1) {
      this.indexCounter = 0;
    }
    this.routine = this.routines[this.shuffledRoutineIndexes[this.indexCounter]];

    setTimeout(() => {
      if (this.routine.url) {
        this.currentImage = this.routine.url;
      }
    }, 250);
  }

  onExit() {
    this.displayContainer = false;
    this.onDone.emit({});
  }

  ngOnInit() {
    this.initRoutines();
  }

  initRoutines() {
    this.api.getData()
      .subscribe(res => {
        setTimeout(() => {

          switch(this.workoutType) { 
            case 'hiit': { 
              this.routines = res.hiit.routines;
               break; 
            } 
            case 'core': { 
              this.routines = res.core.routines;
               break; 
            } 
            case 'cardio': { 
              this.routines = res.cardio.routines;
               break; 
            } 
            case 'resistance': { 
              this.routines = res.resistance.routines;
               break; 
            } 
            default: { 
               console.error('unknown workout type: ' + this.workoutType);
               break; 
            } 
         } 

          this.shuffledRoutineIndexes = this.api.getShuffledRoutineIndexes(this.routines, this.routines.length, []);
          this.routine = this.routines[this.shuffledRoutineIndexes[this.indexCounter]];
          console.log('Routine indexes: ' + JSON.stringify(this.shuffledRoutineIndexes));
          this.displayContainer = true;
          if (this.routine.url) {
            this.currentImage = this.routine.url;
          }
        });
      }, err => {
        console.log(err);
      });
  }

  ngAfterViewInit() {
    // console.log('after view init');
    // this.initRoutines();
  }

  ngOnDestroy() {
    // console.log('on destroy');
  }
}
